import { TelegramSection, type TelegramValue } from './TelegramSection';
import { WhatsAppSection, type WhatsAppValue } from './WhatsAppSection';
import type { SectionStatus, TenantSectionProps } from './types';

export interface ChannelsValue {
  telegram?: TelegramValue;
  whatsapp?: WhatsAppValue;
}

export function channelsStatus(value: ChannelsValue | undefined): SectionStatus {
  const tg = value?.telegram;
  const wa = value?.whatsapp;
  if (tg?.webhookRegistered || wa?.webhookRegistered) return 'complete';
  if (tg?.tokenUploaded || wa?.secretsUploaded) return 'partial';
  return 'empty';
}

/**
 * Canales — por dónde le escriben al negocio.
 *
 * En el wizard Telegram y WhatsApp son dos pasos separados (cada uno con su
 * propio ritmo de secretos + webhook). En edición se muestran juntos bajo una
 * sola tab, porque el operador piensa en "canales", no en "paso 2 y paso 3".
 */
export function ChannelsSection({
  mode,
  tenantId,
  value,
  onSaved,
  testId,
}: TenantSectionProps<ChannelsValue>) {
  return (
    <div data-testid={testId} className="space-y-6">
      <TelegramSection
        mode={mode}
        tenantId={tenantId}
        value={value?.telegram ?? {}}
        onSaved={(patch) => onSaved?.({ telegram: patch })}
      />
      <WhatsAppSection
        mode={mode}
        tenantId={tenantId}
        value={value?.whatsapp ?? {}}
        onSaved={(patch) => onSaved?.({ whatsapp: patch })}
      />
    </div>
  );
}
